import { Injectable, Inject } from '@angular/core';

import { Observable, Subject, Subscription, BehaviorSubject, ReplaySubject } from "rxjs";

import { AppService } from '../app.service';
import { UserService } from '../user/user.service';
import { LaravelApiService } from '../laravel.service';

import { Location } from './location.model';

@Injectable({
  providedIn: 'root'
})
export class LocationService extends AppService {

  private _locations: Location[] = [];
  public locationsSubject: Subject<Location[]>;

  constructor(
    private user: UserService,
    @Inject(LaravelApiService) private laravel: LaravelApiService,
	) {
    super(); // Necessary to get methods from parent class

    this.locationsSubject = new Subject();

    this.laravel.getClientConfig().subscribe((configData) => {
      if (!configData) return;

      Promise.all([
        this.setupLocations()
      ]).then( () => {
      });
    });

    this.user.tempOrgIDSubject.subscribe((orgID) => {
      if (orgID) this.setupLocations();
    })
  }

  get locations(): Location[] {
    return this._locations;
  }

  updateLocation(location) {
    let locationRef = this._find('locations', location.id);
    locationRef = Object.assign(locationRef, location);
    this._update('locations', location);
    this.locationsSubject.next(this._locations);
  }

  location(id: number): Location {
    return this._find('locations', id);
  }

  saveLocation(location: Location) {
    const updateObservable = this.laravel.update("user/locations", location.id, location);
    updateObservable.subscribe((result) => {
      this.updateLocation(location);
    });
  }

  deleteLocation(id: number) {
    const deleteObservable = this.laravel.delete("user/locations", id);
    deleteObservable.subscribe((result) => {
      if (result) {
        this._delete('locations', id);
        this.locationsSubject.next(this._locations);
      }
    });
    return deleteObservable;
  }

  deleteLocations(ids: number[]) {
    const deleteObservable = this.laravel.deleteSeveral("user/locations", ids);
    deleteObservable.subscribe((deletedIds: any[]) => {
      deletedIds.forEach((id) => this._delete('locations', id));
      this.locationsSubject.next(this._locations);
    });
    return deleteObservable;
  }

  setupLocations() {
    return new Promise( (resolve, reject) => {
      let locationSub = this.laravel.list('user/locations');

      locationSub.subscribe( (data) => {
        if (!data || !Array.isArray(data)) return;

        this._locations = data.map((location) => new Location(location));
        this.locationsSubject.next(this._locations);
      });
    });
  }

  centers() {
    return this.laravel.list('user/locations/center');
  }
}
